(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/xperten/javascripts/xperten.js') >= 0) return;  svs.modules.push('/components/sport/xperten/javascripts/xperten.js');

'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const Icon = svs.ui.ReactIcon;
class Xperten extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      useBaseRow: this.props.useBaseRow,
      selectedXpert: this.props.selectedXpert
    });
    this.handleXpertenClick = this.handleXpertenClick.bind(this);
    this.handleChangeUseBaseRow = this.handleChangeUseBaseRow.bind(this);
  }
  componentDidMount() {
    if (!svs.sport.xperten.isBaseRowEmpty(this.props.baseRow)) {
      $('#xperten-button-switch').prop('checked', true);
    }
  }
  handleXpertenClick(xpert) {
    $('.modal-button-right').prop('disabled', false);
    this.props.changeSelectedXpert(xpert);
  }
  handleChangeUseBaseRow() {
    if (svs.sport.xperten.isBaseRowEmpty(this.props.baseRow)) {
      this.props.changeOwnBaseRow();
    } else {
      this.setState(state => ({
        useBaseRow: !state.useBaseRow
      }));
      this.props.changeUseBaseRow();
    }
  }
  render() {
    const xpertChoiches = this.props.xperter.map(xpert => {
      let isDisabled = xpert.full < this.props.baseRow.fullHedges || xpert.half < this.props.baseRow.halfHedges;
      if (!this.state.useBaseRow) {
        isDisabled = false;
      }
      if (xpert.full > this.props.numberOfThreewayEvents) {
        isDisabled = true;
      }
      return React.createElement(svs.sport.xperten.XpertenChoice, {
        cost: xpert.size * this.props.rowPrice,
        disabled: isDisabled,
        key: "".concat(xpert.size, "_").concat(xpert.full, "_").concat(xpert.half),
        onXpertenClick: this.handleXpertenClick,
        selected: xpert.size * this.props.rowPrice === this.state.selectedXpert && !isDisabled
      });
    });
    return React.createElement("div", null, React.createElement("div", {
      className: "align-left line-height-30 f-500 f-bold padding-1 padding-bottom-0"
    }, React.createElement("span", {
      className: "align-middle align-left"
    }, "Vill du utg\xE5 fr\xE5n en egen rad?")), React.createElement("div", {
      className: "panel panel-default margin-1 margin-top-0"
    }, React.createElement("div", {
      className: "panel-body panel-body-button-container row"
    }, React.createElement("div", {
      className: "span6",
      style: {
        padding: 3
      }
    }, React.createElement("div", {
      className: "form-toggle"
    }, React.createElement("input", {
      checked: this.state.useBaseRow === true,
      className: "form-toggle-input form-toggle-challenge form-toggle-radio form-toggle-button",
      id: "own-choice-yes",
      name: "xperten-group",
      onChange: this.handleChangeUseBaseRow,
      type: "radio"
    }), React.createElement("label", {
      className: "form-label",
      htmlFor: "own-choice-yes"
    }, React.createElement("div", {
      className: "form-label-text"
    }, "JA")))), React.createElement("div", {
      className: "span6",
      style: {
        padding: 3
      }
    }, React.createElement("div", {
      className: "form-toggle"
    }, React.createElement("input", {
      checked: this.state.useBaseRow === false,
      className: "form-toggle-input form-toggle-challenge form-toggle-radio form-toggle-button",
      id: "own-choice-no",
      name: "xperten-group",
      onChange: this.handleChangeUseBaseRow,
      type: "radio"
    }), React.createElement("label", {
      className: "form-label",
      htmlFor: "own-choice-no"
    }, React.createElement("div", {
      className: "form-label-text"
    }, "NEJ")))), React.createElement("div", {
      className: "clearfix"
    }))), React.createElement("div", {
      className: "align-left line-height-30 f-500 f-bold padding-1 padding-bottom-0"
    }, React.createElement("span", {
      className: "align-middle align-left"
    }, "V\xE4lj totalpris")), React.createElement("div", {
      className: "panel panel-default margin-1 margin-top-0"
    }, React.createElement("div", {
      className: "panel-body panel-body-button-container row"
    }, xpertChoiches), React.createElement("p", {
      className: "padding-h-1"
    }, "Totalpriset beror p\xE5 vilken radinsats du v\xE4ljer.")));
  }
}
svs.sport.xperten.Xperten = Xperten;

 })(window);